<script>
	import ListExercices from '../components/ListExercices.svelte';

    let data = sessionStorage.getItem('catalog');
    let catalog = JSON.parse(data);

    // console.log(catalog);
</script>

<section id="content" >
    <div class="center">
        <h2 class="routetitle">Exercices</h2>

        <h3>Jambes</h3>
        <ListExercices exercices={catalog.exercices.legs}/>

        <h3>Bras</h3>
        <ListExercices exercices={catalog.exercices.arms}/>

        <h3>Abdominaux</h3>
        <ListExercices exercices={catalog.exercices.abs}/>

        <h3>Planches</h3>
        <ListExercices exercices={catalog.exercices.planks}/>
        
    </div>
</section>

<style>
    #content {
        width: 80%;
        position: absolute;
        top:50px;
        bottom: 0px;
        overflow: auto;
    }

    .center {
        margin: 0 auto; /* Center the DIV horizontally */   
        width: 80%;
    }
</style>